import { AuditLogFilterRequestModel } from "@/models/filter-model";
import { TransactionLogResponseModel } from "@/models/transaction-log";
import { AxiosResponse } from "axios";
import { LogType } from "../constants/app.enums";
import { AuditLog } from "../models/audit-log";
import { PaginationResponse } from "../models/pagination-response";
import { CommonUtils } from "../utils/common";
import { downloadAsync, getAsync, postAsync } from './http-client';

const baseUrl = `${process.env.REACT_APP_API_ENDPOINT_Portal}/v1`;

function getAuditLogs(
  pageIndex: number,
  pageSize: number,
  type: LogType,
  filter: object
): Promise<AxiosResponse<PaginationResponse<AuditLog>>> {
  let url = `${baseUrl}/auditlog?pageIndex=${pageIndex}&pageSize=${pageSize}&type=${type}`;
  url = CommonUtils.buildQuery(url, filter)
  return getAsync(url);
}

function getSystemLogReport(type: LogType): Promise<AxiosResponse<Blob>> {
  const url = `${baseUrl}/auditlog/export-system-report?type=${type}`;
  return downloadAsync(url);
}

function getOperationLogReport(type: LogType): Promise<AxiosResponse<Blob>> {
  const url = `${baseUrl}/auditlog/export-operation-report?type=${type}`;
  return downloadAsync(url);
}

function getTransationLogs(
  pageIndex: number,
  pageSize: number,
  filter: object
): Promise<
  AxiosResponse<PaginationResponse<TransactionLogResponseModel>>
> {
  let url = `${baseUrl}/transactionlog?pageIndex=${pageIndex}&pageSize=${pageSize}`;
  url = CommonUtils.buildQuery(url, filter)
  return getAsync(url);
}

function transactionFilter(model: AuditLogFilterRequestModel) : Promise<AxiosResponse<PaginationResponse<TransactionLogResponseModel>>>{
  const url = `${baseUrl}/auditlog/filter-audit`;
  return postAsync(url,model,undefined,true,false);
};

function auditFilter(
  model: AuditLogFilterRequestModel
): Promise<AxiosResponse<PaginationResponse<AuditLog>>> {
  const url = `${baseUrl}/auditlog/filter-audit`;
  return postAsync(url, model, undefined, true, false);
};

export const AuditLogApi = {
  getAuditLogs,
  getSystemLogReport,
  getOperationLogReport,
  getTransationLogs,
  auditFilter,transactionFilter
};
